export const menuTypes: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  med: {
    shortTitle: "Med",
    shortLower: "med",
    longTitle: "Medical",
    longLower: "medical",
  },
  rec: {
    shortTitle: "Rec",
    shortLower: "rec",
    longTitle: "Recreational",
    longLower: "recreational",
  },
};

const getMenuTypesKey = (value: boolean) =>
  value ? menuTypes.med.shortLower : menuTypes.rec.shortLower;

export const getShortTitle = (value: boolean) =>
  menuTypes[getMenuTypesKey(value)].shortTitle;

export const menuTypeErrorMessage = "multiple_menu_type_error";

export const menuTypeCookieName = "userMedRecPreference";

export enum MenuType {
  Med,
  Rec,
}
